// src/components/settings/TimezoneSettings.js
import React, { useContext } from "react";
import { TimezoneContext } from "../../../utills/TimezoneContext";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { Dropdown, TextComponent } from "../../../components";
import { useTimezoneDate } from "../../../utills/useTimezoneDate";

import styles from "./TimezoneSettings.module.css";

const TimezoneSettings = () => {
  const { timezone, setTimezone } = useContext(TimezoneContext);
  
  const timezones = [
    { id: 1, label: "UTC", value: "UTC" },
    { id: 2, label: "New York (America/New_York)", value: "America/New_York" },
    { id: 3, label: "London (Europe/London)", value: "Europe/London" },
    { id: 4, label: "Dubai (Asia/Dubai)", value: "Asia/Dubai" },
    { id: 5, label: "Karachi (Asia/Karachi)", value: "Asia/Karachi" },
    { id: 6, label: "Kolkata (Asia/Kolkata)", value: "Asia/Kolkata" },
    { id: 7, label: "Tokyo (Asia/Tokyo)", value: "Asia/Tokyo" },
    { id: 8, label: "Sydney (Australia/Sydney)", value: "Australia/Sydney" },
  ];

  const DisplayTime = () => {
    const { formatDate, timezone } = useTimezoneDate();
    const now = formatDate(new Date());
    return (
      <div>
        <TextComponent text={`Current Time (${timezone}): ${now}`} divStyle={{ marginTop: 20 }} />
      </div>
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <TextComponent text={"🌍 App Timezone Settings"} className={styles.labelText}/>

      <TextComponent text={"Select a timezone for your app:"} divStyle={{ marginTop: 20, marginBottom: 10 }} />

      <Dropdown
        value={timezone}
        style={{ color: "var(--primary-color)" }}
        options={timezones}
        onChange={(e) => {
          setTimezone(e)
        }}
      />

      <DisplayTime />
    </div>
  );
};

export default TimezoneSettings;
